import styled from '@emotion/styled/macro';

import { IconWrapperWithDescription } from '../../../../../ui/gologin-header/icons/wrapper';

export const EmptyTableWrapper = styled.div`
  text-align: center;
`;

export const EmptyTableTitle = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: var(--B5B5BA-profile-table);
`;

export const CreateFirstButtonContainer = styled(IconWrapperWithDescription)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  gap: 8px;
  width: fit-content;
  height: 32px;
  border: 1px solid var(--EBEBEB-profile-table);
  border-radius: 16px;
  margin: 32px auto auto;
  cursor: pointer;
  
  :hover {
    background-color: var(--F9F9F9);
  }
`;

export const CreateFirstButtonText = styled.span`
  font-size: 14px;
`;
